import { render, staticRenderFns } from "./CampaignReview.vue?vue&type=template&id=55e16bb0&"
import script from "./CampaignReview.vue?vue&type=script&lang=js&"
export * from "./CampaignReview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CampaignReview.vue"
export default component.exports